// extracted by mini-css-extract-plugin
export default {"loaderContainer":"WebChat_loaderContainer__-qlr5"};